import * as loadingActions from './../actions/loadingActions';
import * as messageActions from './../actions/messageActions';
import * as configActions from './../actions/configActions';

export const unknownError = "An unknown error has occurred. Please try again or contact support for help.";
export const permissionError = "Unauthorized.";
export const notFoundError = "Not Found.";

export var getHeaders = (isIncludeContentType) => {
	var headers = {'Accept': 'application/json'};
	
	if (isIncludeContentType) {
		headers['Content-Type'] = 'application/x-www-form-urlencoded';
	}

	return headers;
};

export var transformFormData = (formData) => {
	var fields = {};
	if (formData instanceof FormData) {
		for (var pair of formData.entries()) {
			fields[pair[0]] = pair[1];
		}	
		formData = fields;
	}

	const encodeElement = (v) => { 
		return encodeURIComponent(v);
	};
	
	var formFields = [];
	for (var i in formData) {
		var val = formData[i];
		if (val === undefined || val === null)
			val = "";
		else if (typeof(val) === "boolean")
			val = formData[i] ? 1 : 0;
		else if (typeof(val) === "string")
			val = encodeElement(val);
		else if (Array.isArray(val)) {
			val = val.map(encodeElement).join(',');
		}
		
		formFields.push(i + "=" + (val !== null ? val : ""));
	}
	
	formData = formFields.join("&");
	if (formData.length === 0)
		formData = null;

	return formData;
}

export var apiRequest = (url, method, formData, dispatch, getState, options = null) => {
    var apiUrl = process.env.REACT_APP_YGL_API_DOMAIN + url;
	var headers = getHeaders(true);
    formData = transformFormData(formData);
    
	if (formData && formData.length > 0)
		formData += "&api_version=" + process.env.REACT_APP_CURRENT_VERSION;
	else {
		if (apiUrl.indexOf("?") !== -1)
			apiUrl += "&";
		else
			apiUrl += "?";

		apiUrl += "api_version=" + process.env.REACT_APP_CURRENT_VERSION;
	}


	var handleResponse = (res) => {
		if (!res.ok) {
			switch(res.status) {
				case 401 : 
					if (dispatch) {
                  dispatch(configActions.loadAccountConfig(null));
               }
					return {ok: false};
				case 403:
					dispatch(messageActions.raiseSystemError(res.status, permissionError));
					return {ok: false};
				case 422 :
					return res.json().then(errors => {
						return { ok: false, status: 422, errors: errors && errors.message ? errors.errors : errors };
					});
				case 404 :
					dispatch(messageActions.raiseSystemError(res.status, notFoundError));
					return notFoundError;
				default:
					res.json().then(obj => {
						if (obj.message)
							dispatch(messageActions.raiseError(obj.message));
						else
							dispatch(messageActions.raiseSystemError(res.status, unknownError));
					});
					return res;
			}
		}
		else
			dispatch(messageActions.resetErrors());

		return res.json().then(json => {
			if (process.env.NODE_ENV !== 'production')
				console.log('res json', json);

			if (json.api_version && process.env.REACT_APP_CURRENT_VERSION !== json.api_version) {
				window.location.reload(true); 
			}

			return {ok: res.ok, json};
		});
	}

	var isLoadingSet = false;
	if (getState().loading.length === 0) {
		dispatch(loadingActions.setLoading());
		isLoadingSet = true;
	}

	if (process.env.NODE_ENV !== 'production')
		console.log(process.env.NODE_ENV, 'api request', apiUrl, method, headers, formData);

	return fetch(apiUrl, {
        method: method,
        credentials: "include",
		mode: 'cors',
		headers: headers,
		body: formData
	}).then((res) => {
		if (isLoadingSet)
			dispatch(loadingActions.removeLoading());
			
		if (process.env.NODE_ENV !== 'production')
			console.log('res', res);
		return handleResponse(res);
	}).catch((e) => {
		if (process.env.NODE_ENV !== 'production')
			console.log('exception', e);
		
			if (isLoadingSet)
            dispatch(loadingActions.removeLoading());
      
         if (!options || !options.hideError)
			   dispatch(messageActions.raiseError("A network error has occurred. Please check your internet connection and try again."));
		return {ok: false};
	});
}



// WEBPACK FOOTER //
// ./src/helpers/apiHelper.js